var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5536",
    "data-name": "Group 5536",
    transform: "translate(-1192.5 -245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1960",
    "data-name": "Rectangle 1960",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(1192.5 245)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar_1_",
    "data-name": "calendar (1)",
    transform: "translate(1206.5 229.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3345",
    "data-name": "Path 3345",
    d: "M.644,161.3H17.488a.645.645,0,0,0,.413-.149c.162-.135,3.852-3.31,4.077-10.164H3.888c-.224,6.221-3.623,9.145-3.658,9.174A.645.645,0,0,0,.644,161.3Z",
    transform: "translate(0 -114.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3346",
    "data-name": "Path 3346",
    d: "M108.422,32.277H105.2v-.645a.645.645,0,0,0-1.289,0v.645h-3.266v-.645a.645.645,0,0,0-1.289,0v.645H96.132v-.645a.645.645,0,0,0-1.289,0v.645H91.621a.638.638,0,0,0-.645.645v1.934h18.091V32.922A.638.638,0,0,0,108.422,32.277Z",
    transform: "translate(-87.067 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3347",
    "data-name": "Path 3347",
    d: "M105.8,302.685a1.94,1.94,0,0,1-1.241.45H90.977v1.934a.644.644,0,0,0,.645.645h16.8a.644.644,0,0,0,.645-.645v-7.225A12.774,12.774,0,0,1,105.8,302.685Z",
    transform: "translate(-87.068 -255.388)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiBooking);
export default __webpack_public_path__ + "static/media/multiBooking.6d7d5775f219665655c9e4c4f1c12d47.svg";
export { ForwardRef as ReactComponent };